import React, { Component } from 'react';
import {Home} from 'react-feather';
import {Link} from 'react-router-dom'

const PARENT_LABELS = {
    'Users':        'Usuarios',
    'Sales':        'Ventas',
    'Digital':      'Productos',
    'Physical':     'Productos',
    'Codes':        'Códigos',
    'Selling':      'Up Selling',
    'Coupon':       'Cupones',
    'Coupons':      'Cupones',
    'Vendors':      'Proveedores',
    'Settings':     'Configuración',
    'Media':        'Archivos',
    'Reports':      'Reportes',
    'Localization': 'Localización',
    'Menus':        'Menús',
    'Menu':         'Menús',
    'Pages':        'Páginas',
    'Dashboard':    'Inicio',
    'Invoice':      'Factura',
};

export class Breadcrumb extends Component {
    render() {
        const { title, parent, parentLink } = this.props;
        const parentLabel = PARENT_LABELS[parent] || parent;
        return (
                <div className="container-fluid">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="page-header-left">
                                    <h3>{title}</h3>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <ol className="breadcrumb pull-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/category"><Home /></Link>
                                    </li>
                                    {parent && (
                                        <li className="breadcrumb-item">
                                            {parentLink
                                                ? <Link to={parentLink}>{parentLabel}</Link>
                                                : parentLabel
                                            }
                                        </li>
                                    )}
                                    <li className="breadcrumb-item active">{title}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

export default Breadcrumb
